<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/D2dP64/tc-custom/9780830858668.jpg?1696374742022" alt="This image is the cover for the book Cat & Dog Prayer"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cat & Dog Prayer
      </h1>
      <p class="bookDescription body article font2">
        <p>When we first become believers, we still have a natural tendency to be self-centered, especially in how we pray. As a result, many Christians prayers that are more of a laundry list of "all about me" requests. Because God doesn't answer these kinds of prayer, we tend to give up on praying believing that God doesn't answer prayer. As a result, we end up checking in from time to time making sure he knows we're there and reminding him of our needs—hoping he'll do something about them. <em>Cat and Dog Prayer</em> will help move you from self-centered prayers to God-focused prayers. You'll learn how to pray, as the authors show:</p>  How to pray prayers that God wants to answer How you've been given a Blank Check by God The six reasons why God says Wait The four reasons why God says No How to pray Cause Me Prayers releasing the Holy Spirit completely in your life, and How you need to be careful about what you pray about—because it can be the very thing that takes you away from God himself!  <p>This book will change the way you pray. It is a natural outflow of <em>Cat and Dog Theology</em> also written by Bob and Gerald.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bob Sjogren, Gerald Robison
      </h2>
      
      <p class="authorDescription body article"><p>Bob Sjogren is the president of UnveilinGLORY, a ministry geared toward awakening the church to a new awareness of God's glory in all areas of life and to see that glory go to all peoples of the world. Bob is co-author of <em>Cat  Dog Theology, Cat  Dog Prayer</em> and <em>A Cat  Dog Look at the Cross.</em> Currently, Bob and his wife, Debby, their four children and his mother reside in Richmond, Virginia.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7d93ddc2